/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
import styled from 'styled-components'

// Styled Components
export const TrustBannerContainer = styled.div`
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    max-width: 500px;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #D4D4D6;
    padding: 6px 12px 12px 12px;
    position: relative;
    margin: 0;

    @media (max-width: 992px) {
        max-width: 100%;
    }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 29px;
`

export const QuoteIconWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 15px;
`

export const NavigationButtons = styled.div`
  display: flex;
  gap: 0px;
`

export const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`

export const Content = styled.div`
  padding-left: 38px;
  padding-right: 0px;
  margin: -5px 0;
`

export const Title = styled.h3`
font-family: "Roboto", Arial, Helvetica, sans-serif;
font-size: 14px;
font-style: italic;
font-weight: 400;
line-height: 23.1px;
color: #282832;
margin-bottom: 6px;
`

export const RatingContainer = styled.div`
  display: flex;
  gap: 0px;
  margin-bottom: -5px;
  margin-left: 38px;
`

export const CustomerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #3e3e47;
`

export const CustomerName = styled.span`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 23.1px;
  color: #282832;
  margin-bottom: 5px;
`

export const VerifiedBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #527a36;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 19.8px;
  margin-top: -4px;
`
